import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { IconButton, Typography } from '@material-ui/core';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import TranscriptSegmentList from './TranscriptSegmentList';
import {
  TranscriptProvider,
  useTranscriptContext,
} from './TranscriptContext';

const TranscriptContainer = withStyles(theme => ({
  root: {
    height: '100%',
    overflow: 'auto',
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: '1',
    height: '100%',
    padding: theme.spacing(2),
  },
  controls: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    flexShrink: 1,
    alignSelf: 'flex-end',
  },
  participants: {},
  segments: {},
}))(({ classes }) => {
  const {
    selectedIndex,
    collection,
    nextTranscript,
    prevTranscript,
  } = useTranscriptContext();

  const transcripts = collection?.resources().list();

  if (transcripts?.length === 0 || !transcripts) {
    return (
      <div className={classes.root}>
        <div className={classes.container}>
          <Typography align="center" color="primary">{'No transcript available, check back later'}</Typography>
        </div>
      </div>
    );
  }

  return (
    <div className={classes.root}>
      <div className={classes.container}>
        {transcripts.length > 1 && (
        <div className={classes.controls}>
          <IconButton
            color="primary"
            onClick={prevTranscript}
          >
            <ChevronLeftIcon />
          </IconButton>
          <Typography>
            {`TRANSCRIPT ${selectedIndex + 1}`}
          </Typography>
          <IconButton
            color="primary"
            onClick={nextTranscript}
          >
            <ChevronRightIcon />
          </IconButton>
        </div>
        )}
        <TranscriptSegmentList
          classes={{
            root: classes.segments,
          }}
        />
      </div>
    </div>
  );
});

function Transcript({ classes }) {
  return (
    <TranscriptProvider>
      <TranscriptContainer classes={classes} />
    </TranscriptProvider>
  );
}

Transcript.propTypes = {
  classes: PropTypes.object.isRequired,
};

Transcript.defaultProps = {
};

export default Transcript;
